import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const CashFlowIndi1 = () => {
  const dates = [
    "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20", 
    "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21", 
    "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22", 
    "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23", 
    "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
  ];

  const currentRatio = [
    0.129282747, 0.085118039, 0.095384073, 0.139974479, 0.111172763, 0.143247628, 0.223814602, 0.125215334, 0.103884659, 
    0.078159384, 0.093996932, 0.196811714, 0.079073648, 0.060435586, 0.063702378, 0.072615862, 0.061810086, 0.088767118, 
    0.081055953, 0.057308456, 0.045963983, 0.061553202, 0.052694046, 0.04633586, 0.054775309, 0.062615891, 0.045789826, 
    0.046712677, 0.042007104, 0.088333994, 0.053047038, 0.037970087, 0.049719311, 0.062661607, 0.07886847, 0.055780892, 
    0.05584321, 0.056148567, 0.063669607, 0.071573553, 0.057471019, 0.055895332, 0.054571554, 0.158082111, 0.070157381, 
    0.048664913, 0.047982538, 0.05566245, 0.077311616, 0.070692203, 0.07002207, 0.070279437, 0.069863861, 0.07258053, 
    0.101330772, 0.101281887, 0.116330174, 0.140442806, 0.173134408, 0.225742365
  ];

  const quickRatio = [
    0.116272036, 0.071091202, 0.081244308, 0.125168419, 0.099762218, 0.131747017, 0.210358363, 0.116674101, 0.096070805, 
    0.069986016, 0.087120886, 0.190232468, 0.07333226, 0.055456459, 0.059247758, 0.068302858, 0.054673181, 0.081678621, 
    0.074294792, 0.108995624, 0.094460821, 0.100512974, 0.096538072, 0.090032994, 0.096663714, 0.101974969, 0.084391146, 
    0.085183998, 0.077179826, 0.12236513, 0.088050224, 0.074337086, 0.085787357, 0.097089827, 0.113468931, 0.090509748, 
    0.090354366, 0.090734433, 0.087583854, 0.09527407, 0.088659947, 0.086658928, 0.084816822, 0.184018776, 0.097451927, 
    0.075070636, 0.07407353, 0.081713577, 0.102660414, 0.094912216, 0.093603558, 0.093395553, 0.092375835, 0.095147068, 
    0.123983913, 0.123513409, 0.138571207, 0.163063935, 0.195803394, 0.248229805
  ];

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Current Ratio", "Quick Ratio"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value}",
      },
    },
    series: [
      {
        name: "Current Ratio",
        type: "line",
        data: currentRatio,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Quick Ratio",
        type: "line",
        data: quickRatio,
        smooth: true,
        lineStyle: { color: "green" },
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default CashFlowIndi1;
